export const getFileViewerUrl = (options: unknown): string | undefined => {
  if (!options || typeof options !== 'object' || Array.isArray(options)) {
    return undefined;
  }
  const url = (options as { fileUrl?: unknown }).fileUrl;
  return typeof url === 'string' && url.trim() ? url.trim() : undefined;
};
